import { ToastType } from '@components/toast';
import { SubjectivityLibraryPostRequestBody, SubjectivityLibraryPostRequestResponse } from '@lio/api-types';

import { SubjectivityLibraryKeys } from '@services/subjectivity/subjectivity-library/subjectivityLibraryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { getApiErrorMessage } from '@utils/getApiErrorMessage';
import { useSnackbar } from 'notistack';

export const useCreateSubjectivityLibraryItem = () => {
  const client = useClient();
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const mutationFn = async (requestBody: SubjectivityLibraryPostRequestBody) =>
    client
      .post(`subjectivity/library-item`, {
        json: requestBody,
      })
      .json<SubjectivityLibraryPostRequestResponse>();

  const result = useMutation({
    mutationFn,
    onSuccess: (data) => {
      // clear queries
      queryClient.refetchQueries({
        predicate: (query) => query.queryKey.includes(SubjectivityLibraryKeys.search[0]),
      });
      return data;
    },
    onError: async (e) => {
      const message = await getApiErrorMessage(e, 'An error occurred saving to library');
      enqueueSnackbar(message, {
        variant: ToastType.Error,
      });
    },
  });
  return { ...result, createSubjectivityLibraryItem: result.mutateAsync };
};
